// src/lib/contact.js
// The one public contact address, written for people and kept away from
// scrapers. Pages show the "(at)" form; a Contact button assembles the real
// address only when someone clicks it, so it never appears in the HTML or as a
// plain string in the bundle.

export const CONTACT_DISPLAY = 'contact(at)globalinfrastructuresherpa.com';

const address = () => ['contact', 'globalinfrastructuresherpa.com'].join('@');

export function openContact(subject, body) {
  const q = new URLSearchParams();
  if (subject) q.set('subject', subject);
  if (body) q.set('body', body);
  const qs = q.toString().replace(/\+/g, '%20');
  window.location.href = `mailto:${address()}${qs ? `?${qs}` : ''}`;
}

// onClick handler for an <a href="#contact"> styled as a link or button.
export const contactClick = (subject, body) => (e) => { e.preventDefault(); openContact(subject, body); };
